var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000183105,
    y: 0.305908,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7382 42.7859C30.3008 50.0524 17.1374 49.9943 7.76453 42.6447L14.6342 39.4244C14.9613 39.2707 15.2753 39.0903 15.573 38.8852C15.6633 38.823 15.7537 38.7581 15.8398 38.6903C16.5875 38.1183 17.2029 37.3916 17.6441 36.56C17.9776 35.921 18.1991 35.2296 18.2991 34.5157C18.3681 34.0526 18.403 33.585 18.4036 33.1167C18.4036 32.3092 18.3598 31.5016 18.3513 30.6927C18.3457 30.2447 18.341 29.7972 18.3372 29.3501L18.6196 29.4913L19.3537 29.871L19.6939 29.9289L23.6299 30.5981L28.0233 31.3463L28.1561 35.864L28.1998 37.3407L28.221 38.0579V38.1045L29.9292 38.799L39.7382 42.7859Z",
    fill: "#E18477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.215 37.9308C27.7298 38.0142 27.2306 37.9369 26.7933 37.7105L18.3693 30.8197C18.3595 30.5006 18.351 30.8352 18.3468 30.5162C18.3411 30.0691 18.3364 29.6216 18.3326 29.1736L18.615 29.3148L19.3491 29.6945L19.6893 29.7524L23.6253 30.4216L28.0188 31.1698L28.1515 35.6875L28.1952 37.1642L28.2164 37.8813V37.9279L28.215 37.9308Z",
    fill: "#A76962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5147 15.0403C36.9368 16.4124 38.8444 18.5381 39.9472 21.094C39.0097 21.1699 38.0854 21.3624 37.1957 21.6671H37.1872C36.9557 21.7462 36.726 21.8333 36.4982 21.9283L36.3571 21.989L36.1326 22.0878C36.0578 22.1203 35.983 22.1556 35.9095 22.1923C35.8361 22.229 35.7684 22.2643 35.6879 22.3024C35.6074 22.3406 35.5467 22.3773 35.4691 22.4168C35.3914 22.4563 35.3406 22.486 35.2771 22.5227C35.1246 22.6074 34.975 22.6963 34.8281 22.7881C34.7698 22.8238 34.7119 22.8606 34.6545 22.8982C34.0883 23.2647 33.5567 23.6819 33.0662 24.1448C32.4465 24.7307 31.8677 25.4041 31.231 26.0055C30.6849 26.5559 30.0453 27.0048 29.342 27.3311C27.9811 27.917 26.407 28.2558 24.9938 28.7429L18.3585 31.037C18.3585 30.9326 17.6074 30.19 16.6644 29.285C14.1825 26.9255 12.7444 23.6734 12.6691 20.2497C12.4404 9.90714 24.59 6.8662 32.8573 9.08267C34.1705 9.43628 35.4194 9.99568 36.5575 10.7401C37.3113 11.2275 38.0009 11.8075 38.6102 12.4667C39.3213 13.2317 39.8924 14.1157 40.2973 15.0784L40.1858 15.0587C38.3118 14.7131 36.3909 14.7069 34.5147 15.0403Z",
    fill: "url(#paint0_linear_420_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9471 21.0941C39.0097 21.17 38.0854 21.3626 37.1956 21.6673H37.1871C36.9528 21.7416 36.7228 21.8288 36.4982 21.9285L36.357 21.9892L36.1297 22.0908C36.0549 22.1247 35.9815 22.1586 35.9066 22.1953C35.8318 22.232 35.7655 22.2673 35.685 22.3054C35.6045 22.3435 35.5438 22.3802 35.4662 22.4198C35.3885 22.4593 35.3377 22.4889 35.2742 22.5257C35.1217 22.6104 34.972 22.6993 34.8252 22.7911L34.6516 22.9012C34.0854 23.2676 33.5538 23.6849 33.0633 24.1478C32.4436 24.7337 31.8648 25.4071 31.228 26.0085C31.0219 26.0932 30.8172 26.1821 30.6125 26.2711C30.6379 26.2598 30.4502 23.8711 30.4558 23.6297C30.4794 22.7073 30.5847 21.7889 30.7706 20.8852C31.1292 19.1473 30.9005 17.5308 31.2464 15.7492C31.3195 15.3515 31.4137 14.958 31.5288 14.5704C32.1189 14.1299 32.9405 13.9944 33.6563 13.8913C35.3716 13.6442 37.1363 13.8786 38.7866 14.3981C39.0596 14.4845 39.3277 14.5854 39.5899 14.7002C39.7142 14.7553 39.8356 14.8146 39.9556 14.8781C40.0614 14.9578 40.176 15.0251 40.2972 15.0786C38.385 14.7258 36.4256 14.7129 34.509 15.0405C36.9332 16.4116 38.8428 18.5374 39.9471 21.0941Z",
    fill: "url(#paint1_linear_420_625)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9482,
    cy: 25.3956,
    rx: 2.4,
    ry: 2.4,
    fill: "#E18477"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.7084,
    cy: 25.3955,
    rx: 2.14871,
    ry: 2.14871,
    fill: "#A76962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7416 23.1312L18.3599 31.1782L27.7397 36.6587C29.0863 37.161 30.5941 36.5586 31.2239 35.2667C32.5736 32.5025 34.7392 28.1387 34.454 26.5138C34.0305 24.1138 32.9011 23.2667 32.9011 23.2667C33.0583 22.3255 33.2145 21.3872 33.3698 20.4516C33.5477 19.3914 33.7736 18.2846 33.511 17.2187C33.2103 15.9975 32.287 15.4752 31.5275 14.5618C29.5284 17.1368 26.2418 18.5924 23.3717 20.0676C21.8893 20.8469 17.7416 23.1312 17.7416 23.1312Z",
    fill: "#E18477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2657 21.4666C23.5731 21.1986 24.9173 21.1627 26.237 21.3607",
    stroke: "#00214E",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6029 21.482C31.4099 21.2956 32.2414 21.2379 33.0664 21.3112",
    stroke: "#00214E",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3516 26.9148C27.1409 27.0227 27.0402 27.268 27.1146 27.4928C27.1889 27.7175 27.416 27.8546 27.6495 27.8155",
    stroke: "#00214E",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8993 25.455C29.8993 25.455 29.9403 26.2526 30.128 26.6267C30.2085 26.7877 30.3341 26.9232 30.4104 27.0841C30.7224 27.6954 30.2184 27.8253 29.7313 27.8253",
    stroke: "#00214E",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7382 42.7859C30.3008 50.0524 17.1374 49.9943 7.76453 42.6447L14.6342 39.4245C14.9613 39.2707 15.2753 39.0903 15.573 38.8852C15.6633 38.823 15.7537 38.7581 15.8398 38.6903C16.5875 38.1183 17.2029 37.3916 17.6441 36.56C17.9776 35.921 18.1991 35.2296 18.2991 34.5157C18.3988 34.6124 18.5034 34.7038 18.6125 34.7896C19.4782 35.4297 20.4176 35.9634 21.4106 36.3793C21.8928 36.5804 22.3858 36.7543 22.8873 36.9002C24.3985 37.3409 25.9763 37.5077 27.5462 37.3929C27.7636 37.376 27.9824 37.3548 28.1998 37.3393L28.221 38.0565V38.103L29.9292 38.7976L39.7382 42.7859Z",
    fill: "#00214E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.2198,
    cy: 23.5841,
    r: 2.68235,
    stroke: "white",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.7217,
    cy: 23.1607,
    rx: 2.68235,
    ry: 2.68235,
    stroke: "white",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9017 23.5843L30.0391 23.4008",
    stroke: "white",
    strokeWidth: 0.198265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0192 29.4403C25.0585 29.3785 25.1217 29.3358 25.1937 29.3224C25.2658 29.3091 25.3401 29.3262 25.399 29.3697C25.6912 29.5759 26.2291 30.0135 26.9915 30.1646C28.0305 30.3721 28.9312 29.9556 29.1472 30.2239C29.2686 30.3749 29.1204 30.5599 28.8366 30.7956C28.2358 31.2443 27.4796 31.4321 26.7387 31.3166C25.7392 31.1288 24.9882 29.9712 24.9882 29.5603C24.9884 29.5184 24.9991 29.4771 25.0192 29.4403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5877,
    cy: 23.5592,
    rx: 0.461647,
    ry: 1.12094,
    transform: "rotate(-85.77 24.5877 23.5592)",
    fill: "#00214E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.8599,
    cy: 23.3304,
    rx: 1.12094,
    ry: 0.461647,
    transform: "rotate(-8.85999 31.8599 23.3304)",
    fill: "#00214E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_625",
    x1: 28.6489,
    y1: 33.4422,
    x2: 45.3335,
    y2: 12.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16243F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_625",
    x1: 30.4572,
    y1: 26.2707,
    x2: 40.2972,
    y2: 26.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16243F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_625"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.000183105,
    y: 0.305908,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/Cs.d7c241e8befb7989f493c804632a08fb.svg";
export { ForwardRef as ReactComponent };